import { VDBText } from "@components/atoms";
import { SpaceType } from "@components/atoms/Spacer/types";
import { useTypographyStore } from "@redux/slices/typographySlice";
import React from "react";
import styled, { DefaultTheme } from "styled-components/native";
import { css } from "styled-components/native";
import { useTheme } from "styled-components/native";

const CommentBodySection = (props: any) => {
  const { children, background, borderRadius } = props;
  const theme = useTheme();
  const typography = useTypographyStore();

  return (
    <Container background={background} borderRadius={borderRadius}>
      <VDBText type={typography["Body-R"]} color={theme["core-06"]}>
        {children}
      </VDBText>
    </Container>
  );
};
const Container = styled.View<{
  background: String;
  borderRadius: number;
}>`
  padding: ${SpaceType.Double}px;
  background-color: ${({ background, theme }) =>
    theme[background as keyof DefaultTheme] as string};
  ${({ borderRadius }) =>
    borderRadius &&
    css`
      border-bottom-left-radius: ${borderRadius}px;
      border-bottom-right-radius: ${borderRadius}px;
    `}
`;
export default CommentBodySection;
